import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';

import { ServerHtmlDirective } from 'ish-core/directives/server-html.directive';
import { CMSFacade } from 'ish-core/facades/cms.facade';
import { IconModule } from 'ish-core/icon.module';
import { ContentPageTreeView } from 'ish-core/models/content-page-tree-view/content-page-tree-view.model';
import { ContentPageletView } from 'ish-core/models/content-view/content-view.model';
import { ContentPageRoutePipe } from 'ish-core/routing/content-page/content-page-route.pipe';
import { CMSComponent } from 'ish-shared/cms/models/cms-component/cms-component.model';

@Component({
  selector: 'ish-cms-navigation-page',
  templateUrl: './cms-navigation-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, IconModule, ServerHtmlDirective, ContentPageRoutePipe],
})
export class CMSNavigationPageComponent implements CMSComponent, OnChanges {
  private cmsFacade = inject(CMSFacade);

  readonly pagelet = input.required<ContentPageletView>();

  pageTree$: Observable<ContentPageTreeView>;

  private openedPages: string[] = [];

  ngOnChanges(): void {
    const pagelet = this.pagelet();
    if (pagelet?.hasParam('Page')) {
      this.pageTree$ = this.cmsFacade.completeContentPageTree$(
        pagelet.stringParam('Page'),
        pagelet.numberParam('SubNavigationDepth', 0)
      );
    }
  }

  showSubMenu(childCount: number) {
    const pagelet = this.pagelet();
    return (pagelet.hasParam('SubNavigationDepth') && pagelet.numberParam('SubNavigationDepth') > 0 && childCount) ||
      pagelet.hasParam('SubNavigationHTML')
      ? true
      : false;
  }

  subMenuShow(subMenu: HTMLElement) {
    subMenu.classList.add('hover');
  }

  subMenuHide(subMenu: HTMLElement) {
    subMenu.classList.remove('hover');
  }

  /**
   * Indicate if specific content page is expanded.
   */
  isOpened(uniqueId: string): boolean {
    return this.openedPages.includes(uniqueId);
  }

  /**
   * Toggle content page open state.
   */
  toggleOpen(uniqueId: string) {
    const index = this.openedPages.findIndex(id => id === uniqueId);
    index > -1 ? this.openedPages.splice(index, 1) : this.openedPages.push(uniqueId);
  }
}
